import React, { useMemo, useState } from "react";
import { Box, Card, CardContent, CardMedia, Container, Typography } from "@mui/material";
import Accordions from "src/components/Accordion";
import PageTitleWrapper from "src/components/PageTitleWrapper";
import PageHeader from "src/components/pageHeader";
import AddSpecializationsForm from "../addSpecializations";
import {
    useDeleteSpecializationMutation,
    useDeleteSubSpecializationMutation,
    useGetSpecializationDetailsQuery,
    usePostSubSpecializationMutation,
    useUpdateSpecializationMutation,
    useUpdateSubSpecializationMutation,
} from "src/reduxServer/services/specializations/index";
import Loader from "src/components/Loader";
import { showToast } from "src/utils/toastfy";
import { useTranslation } from "react-i18next";
import CommonDialog from "src/utils/commenModel";
import { PageIcons } from "src/assets/icons";
import Paginations from "src/components/Pagination/Pagination";
import NoDataFound from "src/components/NoDataFound";
import { useSelector } from "react-redux";
import { RootState } from "src/reduxServer/store";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { SubSpecializationsPayload } from "src/reduxServer/services/specializations/types";
import AddSubSpecializationsForm from "./addSub_Specialization";

interface formValues {
    id?: number | string;
    name_en: string;
    description_en: string;
    name_ar: string;
    description_ar: string;
    specialization: number | string; // parent specialization id
    is_active: boolean;


}



const ITEMS_PER_PAGE = 10;

const SpecializationsDetail = () => {
    const { t } = useTranslation();
    const lng = useSelector((state: RootState) => state.language.lang) || "ar";
    const { id } = useParams();
    const defaultFaqValues: formValues = {
        name_en: "",
        name_ar: "",
        description_en: "",
        description_ar: "",
        specialization: id ? id : undefined,
        is_active: true

    };

    const [openModel, setOpenModel] = useState(false);
    const [specializationsForm, setSpecializationsForm] = useState<formValues>(defaultFaqValues);

    const [deleteTarget, setDeleteTarget] = useState<any>(null);
    const [openAlert, setOpenAlert] = useState(false);
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1);
    const { data, isLoading, refetch } = useGetSpecializationDetailsQuery(Number(id));
    const [addSubSpecializations] = usePostSubSpecializationMutation();
    const [updateSpecializations] = useUpdateSubSpecializationMutation();
    const [deleteSpecializations] = useDeleteSubSpecializationMutation();



    const SpecializationsList =
        data?.data?.sub_categories?.flatMap((item: any) => [
            {
                // id: item.id,
                title: lng === "ar" ? item.name_ar : item.name_en,
                Sub_title: "",
                content: lng === "ar" ? item.description_ar : item.description_en,
                Sub_content: "",
                lang: lng,
                full: item,
            },
        ]) || [];


    const resetForm = () => setSpecializationsForm(defaultFaqValues);

    // ✅ PAGINATED DATA
    const paginatedSpecializations = useMemo(() => {
        return SpecializationsList.slice(
            (page - 1) * ITEMS_PER_PAGE,
            page * ITEMS_PER_PAGE
        );
    }, [SpecializationsList, page]);

    const handleEdit = (item: any) => {
        const f = item.full;

        setSpecializationsForm({
            id: f.id,
            name_en: f.name_en,
            name_ar: f.name_ar,
            description_en: f.description_en,
            description_ar: f.description_ar,
            specialization: id ? parseInt(id, 10) : undefined ,
            is_active: f.is_active

        });

        setOpenModel(true);
    };
    const handleModalClose = () => {
        resetForm();
        setOpenModel(false);
        setLoading(false)

    };

    const handleOpenModel = () => {
        setSpecializationsForm(defaultFaqValues);
        setOpenModel(true);
    };


    const handleSubmit = async (form: SubSpecializationsPayload) => {
        try {
            setLoading(true)
            if (specializationsForm.id) {
                const res = await updateSpecializations({
                    id: specializationsForm.id,
                    data: form,
                }).unwrap();

                // showToast("success", t(res?.message));
            } else {
                const res = await addSubSpecializations(form).unwrap();
                // showToast("success", t(res.message));
            }

            refetch();
            handleModalClose();
        } catch (err: any) {
            console.error("FAQ Submit Error:", err);
            showToast("error", err?.data?.message || t("Something went wrong"));
            handleModalClose();
        }
    };
    const handleDeleteClick = (item: any) => {
        console.log("Delete Values>>>>>", item.full)
        const data = item.full;
        setDeleteTarget({
            id: data.id,
            name_en: item.title,
            name_ar: item.sub_title,
            description_en: item.content,
            description_ar: item.sub_content,
        });
        setOpenAlert(true);
    };

    const confirmDelete = async () => {
        if (!deleteTarget?.id) return;
        setLoading(true)
        try {
            const res = await deleteSpecializations(deleteTarget.id).unwrap();
            showToast("success", t(res.message));
            refetch();
            setLoading(false)

        } catch (err) {
            console.error(err);
            showToast("error", t("Failed to delete subSpecializations"));
            setLoading(false)

        }

        setOpenAlert(false);
        setDeleteTarget(null);
    };



    return (
        <>
            <Helmet>
                <title>Specializations</title>
            </Helmet>
            <PageTitleWrapper>
                <PageHeader
                    title={t("subSpecialization")}
                    buttonLabel={t("addNew")}
                    onButtonClick={handleOpenModel}
                    startIcon={<PageIcons.Add />}
                />
            </PageTitleWrapper>



            <Box
                sx={{
                    height: "calc(100vh - 180px)",
                    overflowY: "auto",
                    padding: 2,
                }}
            >
                <Container maxWidth="xl">

{          data?.data?.length === 0?(""):(
         <Card
  sx={{
    width: "100%",
    borderRadius: 3,
    overflow: "hidden",
    boxShadow: 3,
    backgroundColor: "#fff",
    marginBottom: 3,
  }}
>
  <Box
    sx={{
      display: "flex",
      width: "100%",
      minHeight: 150,

      // Mobile responsive
      "@media (max-width: 768px)": {
        flexDirection: "column",
      },
    }}
  >
    {/* LEFT SIDE - IMAGE */}
    <Box
      sx={{
        width: "45%",
        minHeight: 250,
justifyContent: "center",
display: "flex",
        "@media (max-width: 768px)": {
          width: "100%",
          minHeight: 250,
        },
      }}
    >
      <CardMedia
        component="img"
        image={data?.data?.icon_url}
        alt={
          lng === "ar"
            ? data?.data?.name_ar
            : data?.data?.name_en
        }
        sx={{
          width: "50%",
          height: "50%",
          minHeight: 250,
          objectFit: "cover",
marginTop: 2,
          "@media (max-width: 768px)": {
            minHeight: 250,
          },
        }}
      />
    </Box>

    {/* RIGHT SIDE - CONTENT */}
    <CardContent
      sx={{
        width: "55%",
        padding: "40px",

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",

        "@media (max-width: 768px)": {
          width: "100%",
          padding: "25px",
        },
      }}
    >
      {/* Label */}
      <Typography
        variant="body2"
        sx={{
          color: "primary.main",
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 1,
          marginBottom: 1,
        }}
      >
        {t("specialization")}
      </Typography>

      {/* Name */}
      <Typography
        variant="h3"
        fontWeight={700}
        sx={{
          color: "#172554",
          marginBottom: 2,

          "@media (max-width: 768px)": {
            fontSize: "2rem",
          },
        }}
      >
        {lng === "ar"
          ? data?.data?.name_ar
          : data?.data?.name_en}
      </Typography>

      {/* Small Line */}
      <Box
        sx={{
          width: 60,
          height: 4,
          backgroundColor: "primary.main",
          borderRadius: 2,
          marginBottom: 3,
        }}
      />

      {/* Description Title */}
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{
          marginBottom: 1,
        }}
      >
        {t("description")}
      </Typography>

      {/* Description */}
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          lineHeight: 1.8,
          fontSize: "16px",

          display: "-webkit-box",
          WebkitLineClamp: 5,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {lng === "ar"
          ? data?.data?.description_ar
          : data?.data?.description_en}
      </Typography>
    </CardContent>
  </Box>
</Card>
)
}
                    {isLoading ? (
                        <Loader size={60} />
                    ) : SpecializationsList.length === 0 ? (
                        <Box display="flex" justifyContent="center" p={5}>
                            <NoDataFound />
                        </Box>
                    ) : (
                        <>
                            <Card sx={{ minHeight: "500px" }}>
                                <Accordions
                                    items={paginatedSpecializations}
                                    onEdit={handleEdit}
                                    onDelete={handleDeleteClick}
                                />
                            </Card>
                            <Paginations
                                page={page}
                                totalItems={SpecializationsList.length}
                                itemsPerPage={ITEMS_PER_PAGE}
                                onChange={setPage}
                            />
                        </>
                    )}
                </Container>
            </Box>

            <AddSubSpecializationsForm
                key={`${openModel}-${specializationsForm.id ?? 'new'}`}
                open={openModel}
                title={specializationsForm.id ? t("editeSpecialization") : t("addNew")}
                onClose={handleModalClose}
                onSubmit={handleSubmit}
                initialValues={specializationsForm}
                loading={loading}
                subId={id}
            />

            <CommonDialog
                open={openAlert}
                onClose={() => setOpenAlert(false)}
                title={t("deleteConform")}
                content={deleteTarget?.name_en}
                onConfirm={confirmDelete}
                confirmText={t("Confirm")}
                cancelText={t("Cancel")}
                loading={loading}
            />
        </>
    );
};

export default SpecializationsDetail;
